import { defineStore } from "pinia";

interface State {
  loadingCount: number;
}

export const useLoadingSpinnerStore = defineStore("loadingspinner", {
  state: (): State => ({
    loadingCount: 0, // track active loaders
  }),
  getters: {
    globalLoading: (state) => state.loadingCount > 0, // true if any active loader
  },
  actions: {
    start() {
      this.loadingCount += 1;
      console.debug("loading count: ", this.loadingCount);
    },
    stop() {
      if (this.loadingCount > 0) this.loadingCount -= 1;
      console.debug("loading count: ", this.loadingCount);
    },
    clear() {
      this.$reset();
    },
  },
});
